export default {
  defaultProps: {
    variant: 'elevation'
  }
}
